import React from 'react';
import classnames from 'classnames';
import { Layout } from 'tea-component';
import usePageLog from '@intelligence/v3/_hooks/usePageLog';

import './index.scss';

const { Content } = Layout;

interface IReusePageTemplateProps extends IBaseProps {
  /**
   * 页面标题
   */
  title: string | React.ReactElement;
  /**
   * 页面副标题
   */
  subTitle?: string | React.ReactElement;
  /**
   * 页面打点配置的键
   */
  pageLogKey?: string;
}

const ReusePageTemplate: React.FC<IReusePageTemplateProps> = (props) => {
  const { style, className, title, subTitle, pageLogKey, children } = props;

  usePageLog(pageLogKey);

  return (
    <Content style={style} className={classnames('dbi-reuse-page-template', className)}>
      <Content.Header className="dbi-reuse-page-template__header" title={title} subtitle={subTitle} operation={null} />
      <Content.Body full className="dbi-reuse-page-template__body">
        {children}
      </Content.Body>
    </Content>
  );
};

export default ReusePageTemplate;
